import { FaArrowRight } from "react-icons/fa6"
import ContainerLayout from "./containerlayout"
import ResponsiveTable from "../table"
import { useEffect, useState } from "react";
import ModelButton from "../modelBtn/modelButton";
import RegistrationInfoPopUp from "./registrationInfoPopUp";
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";
import { MyTable } from "../campusLife/swimmingPoolHours";

const ImportantDates = ({ admission }) => {



    const header2 = admission?.header2
    const registerButton = admission?.registerButton?.items?.map(item => {
        item = item?.content?.properties
        return {
            label: item?.label,
            url: item?.pagePath?.route?.path
        }

    })[0]


    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);


    const [tableData, setTableData] = useState({
        headers: [],
        mobile: [],
        contents: []
    });

    useEffect(() => {
        const headers = [];
        const mobile = [];
        const contents = [];

        admission?.table?.items.forEach((item) => {
            // Extract the label for the header
            const headerLabel = item?.content?.properties?.label;
            headers.push(headerLabel);
            mobile.push(headerLabel);

            const rowData = [];
            item?.content?.properties?.content?.items?.forEach((contentItem) => {
                // Extract the content for each cell
                const cellContent = contentItem?.content?.properties?.richText?.markup;
                rowData.push(DecodeHtml({ html: cellContent }));
            });
            contents.push(rowData);
        });

        setTableData({ headers, mobile, contents });
    }, [admission?.table]);



    return (
        <ContainerLayout>
            <h1 className="w-auto   text-4xl font-bold ">{header2}</h1>
            <>
                <button
                    onClick={() => (modalOpen ? closed() : open())}
                    className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                    <span className="text-white text-base font-bold capitalize flex items-center gap-3">{registerButton?.label} <FaArrowRight /></span>
                </button>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    <RegistrationInfoPopUp url={registerButton?.url} />
                </ModelButton>
            </>
            {/* <ResponsiveTable {...table} /> */}
            <p className="whitespace-pre-line intakes">{DecodeHtml({html:admission?.intakesTablesNew?.markup})}</p>
            {/* <MyTable headers={tableData.headers} mobile={tableData.mobile} contents={tableData.contents} /> */}
        </ContainerLayout>
    )
}
ImportantDates.propTypes = {
    admission: PropTypes.object
}
export default ImportantDates